import React from 'react'
import Form from '../Form'
import './style.scss'
import { FaClock, FaPhone, FaEnvelope, FaMapMarkerAlt } from 'react-icons/fa'
import { useLanguage } from '../../i18n'

const ContactArea = ({ className }) => {
    const { t } = useLanguage();

    return (
        <div className={className}>
            <div className="container">
                <div className="row">
                    <div className="col-lg-5 col-12">
                        <div className="contactInfo">
                            <span className="subTitle">{t('contact.subtitle')}</span>
                            <h2>{t('contact.title')}</h2>
                            <p>{t('contact.description')}</p>
                        </div>

                        <div className="contactCards">
                            <div className="contactCard">
                                <div className="cardIcon">
                                    <FaMapMarkerAlt />
                                </div>
                                <div className="cardContent">
                                    <h4>{t('contact.officeAddress')}</h4>
                                    <p>40, Hanuman Lane, 2nd Floor,<br />Baba Kharak Singh Marg,<br />Connaught Place, New Delhi-110001</p>
                                </div>
                            </div>

                            <div className="contactCard">
                                <div className="cardIcon">
                                    <FaPhone style={{ transform: 'scaleX(-1)' }} />
                                </div>
                                <div className="cardContent">
                                    <h4>{t('contact.phoneNumber')}</h4>
                                    <p><a href="tel:+919555690946">+91-9555 690 946</a></p>
                                    <p><a href="tel:+917905705906">+91-7905 705 906</a></p>
                                </div>
                            </div>

                            <div className="contactCard">
                                <div className="cardIcon">
                                    <FaEnvelope />
                                </div>
                                <div className="cardContent">
                                    <h4>{t('contact.emailAddress')}</h4>
                                    <p><a href="mailto:contact@legalcorridors.com">contact@legalcorridors.com</a></p>
                                    <p><a href="mailto:legalcorridor@gmail.com">legalcorridor@gmail.com</a></p>
                                </div>
                            </div>

                            <div className="contactCard">
                                <div className="cardIcon">
                                    <FaClock />
                                </div>
                                <div className="cardContent">
                                    <h4>{t('contact.workingHours')}</h4>
                                    <p>{t('contact.workingHoursValue')}</p>
                                    <p>{t('contact.emergency')}</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-12 col-lg-7">
                        <div className="contactFormWrapper">
                            <span className="subTitle">{t('contact.scheduleConsultation')}</span>
                            <h3>{t('contact.requestCallback')}</h3>
                            <p>{t('contact.formDescription')}</p>
                            <Form />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default ContactArea